"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function JoinPanel(props) {
    const { hosts, onSelectHost, onCancel, className } = props;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'JoinPanel_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'JoinPanel_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.joiningTitle) }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'JoinPanel_Subtitle', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.joiningSubtitle) }), hosts.length > 0 && ((0, jsx_runtime_1.jsx)(List, { "data-e2e": 'JoinPanel_List', children: (0, jsx_runtime_1.jsx)(StyledScrollView, { "data-e2e": 'JoinPanel_StyledScrollView', children: hosts.map((user, index) => {
                        return ((0, jsx_runtime_1.jsxs)(ListItem, { onClick: () => onSelectHost(user), "data-e2e": 'JoinPanel_ListItem', children: [(0, jsx_runtime_1.jsx)(StyledAvatar, { image: user.avatar, "data-e2e": 'JoinPanel_StyledAvatar' }), `${user.name}'s Classroom`] }, index));
                    }) }) })), (0, jsx_runtime_1.jsx)(CancelButton, { onClick: onCancel, "data-e2e": 'JoinPanel_CancelButton', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.cancelJoin) })] }));
}
exports.default = JoinPanel;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: column;

  width: 150px;
  padding: 10px;

  color: ${props => props.theme.white};

  background: ${props => props.theme.black_50};
  border-radius: 2px;

  cursor: pointer;

  pointer-events: auto;
`;
const Title = styled_components_1.default.div `
  margin: 0 auto 5px auto;

  color: ${props => props.theme.white};
  font-weight: bold;
  font-size: 11px;
`;
const Subtitle = styled_components_1.default.div `
  margin: 0 auto;

  color: ${props => props.theme.white};
  font-size: 11px;
`;
const StyledAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 30px;
  height: 30px;
  margin: auto 10px auto 0;

  background: ${props => props.theme.white};
  border-radius: 50%;
  box-shadow: 0 1px 2px 0 ${props => props.theme.black_50};
`;
const List = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  max-height: 300px;
  padding: 10px 0 10px 0;
  overflow: hidden;
`;
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  display: flex;
  flex-direction: column;

  width: 100%;
`;
const ListItem = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 50px;

  color: ${props => props.theme.white};
  font-size: 12px;
`;
const CancelButton = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 40px;

  color: ${props => props.theme.white};
  font-size: 11px;
`;
